import { render, staticRenderFns } from "./DocRaptor.vue?vue&type=template&id=774f407b&"
import script from "./DocRaptor.vue?vue&type=script&lang=js&"
export * from "./DocRaptor.vue?vue&type=script&lang=js&"
import style0 from "./DocRaptor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports